interface OnPageEditingProps {
  'data-epi-block-id': string | number;
  'data-epi-content-name': string;
  'data-epi-use-mvc': 'True';
  'data-content-group': true;
}

const getOnPageEditingProps = (
  propertyName?: string | null,
  id?: string | number
): Partial<OnPageEditingProps> | Record<string, never> => {
  if (!propertyName || !id) {
    return {};
  }

  return {
    'data-epi-block-id': id,
    'data-epi-content-name': propertyName,
    'data-epi-use-mvc': 'True',
    'data-content-group': true
  };
};

export default getOnPageEditingProps;
